import Vue from 'vue';
import jwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';

// Returns true if user has one of the permissions specified in function param
const hasPermission = (permissions) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }

  const token = Vue.prototype.$keycloak?.token || Cookies.getJSON('accessToken');
  if (!token) {
    return false;
  }

  const decodedToken = jwtDecode(token);
  const userPermissions = decodedToken?.data?.permissions || [];

  for (let i = 0; i < permissions.length; i += 1) {
    for (let j = 0; j < userPermissions.length; j += 1) {
      if (permissions[i] === userPermissions[j]) {
        return true;
      }
    }
  }

  return false;
};

export { hasPermission };
